import DenominatorStorage from '../storage/denominator-storage';

export default function reducer(state = DenominatorStorage, action) {
  let newState;
  switch (action.type) {
    case 'DENOMINATOR_OPEN':
      newState = { ...state };
      newState.open(action.item, action.onclose);
      return newState;
    case 'DENOMINATOR_ACCEPT':
      newState = { ...state };
      newState.accept();
      return newState;
    case 'DENOMINATOR_CLOSE':
      newState = { ...state };
      newState.close();
      return newState;
    case 'DENOMINATOR_CHANGE':
      newState = { ...state };
      newState.changeDenomination(action.item);
      return newState;
    case 'DENOMINATOR_LOCK':
      newState = { ...state };
      newState.locked = true;
      return newState;
    case 'DENOMINATOR_UNLOCK':
      newState = { ...state };
      newState.locked = false;
      return newState;
    default:
      return state;
  }

  // return state;
}
